import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MenuItem } from "@/types/menu.type";
import SidebarComponent from "./SidebarComponent.vue";
import securityService from "@/service/security.service";
import { AppType } from "@/types/app.type";
import { onMounted, reactive } from "vue";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const items: MenuItem[] = reactive([
  {
    icon: "el-icon el-icon-home fas",
    index: "/stations",
    title: "menu.home",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-map-marker fas",
    index: "/stations/stations",
    title: "menu.stations",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-bell fas",
    index: "/stations/alerts",
    title: "menu.alerts",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-eye fas",
    index: "/stations/samplingPoints",
    title: "menu.samplingPoints",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-chart-area fas",
    index: "/stations/graph",
    title: "menu.graph",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-file-export fas",
    index: "/stations/report",
    title: "menu.report",
    disabled: false,
  },
]);

const store = useStore<RootState>();

onMounted(async () => {
  const canAdmin = securityService.canAccessToApp(AppType.ADMIN);
  const canSupport = securityService.canAccessToApp(AppType.SUPPORT);
  const canStations = securityService.canAccessToApp(AppType.STATIONS);
  const canProcessTracking = securityService.canAccessToApp(AppType.PROCESS_TRACKING);
  const canAccessIssueMonitoring = securityService.canAccessToApp(AppType.ISSUE_MONITORING);

  if (!canSupport && canStations && !canAdmin && !canProcessTracking && !canAccessIssueMonitoring) {
    items.shift();
  }
  if (store.state.auth.user?.id) {
    let userRoutes = await getAvailableRoutes(store.state.auth.user.id);

    if (userRoutes && Array.isArray(userRoutes) && userRoutes.length > 0) {
      items.forEach((item) => {
        item.disabled = !userRoutes.includes(item.index);
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SidebarComponent, { items: _unref(items) }, null, 8, ["items"]))
}
}

})